import Loading from '@cartwhl/ui/atoms/Loading';

export default function PlaceHolder({ text }: { text: string }) {
  return (
    <div className="bg-gray-15 dark:bg-gray-75 flex aspect-video w-full animate-pulse flex-col items-center justify-center gap-4 rounded-2xl">
      <Loading />
      <span>{text}</span>
    </div>
  );
}
